<template>
    <div id="alert" @click="closeAlert">
        <div class="content" @click.stop.prevent="">
            <p class="text" v-html="text"></p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Alert",
        props: ['text'],
        methods: {
            closeAlert: function () {
                $eventbus.$emit('close:alert');
            },
        }
    }
</script>

<style scoped>

</style>
